module.exports = __webpack_public_path__ + "img/nuclei-06.1b1612c1.png";